document.documentElement.classList.remove('no-js');

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('details[open]').forEach((details) => {
    details.removeAttribute('open');
  });
});

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;

  const form = select.closest('[data-product-form]');
  const price = form?.closest('.product-info')?.querySelector('[data-product-price] span');
  const selected = select.options[select.selectedIndex];

  const submit = form?.querySelector('.product-form__submit');
  if (submit && selected) {
    const available = selected.dataset.available === 'true';
    submit.disabled = !available;
    submit.textContent = available ? submit.dataset.addLabel : submit.dataset.soldLabel;
    submit.removeAttribute('aria-busy');
  }

  if (price && selected?.dataset.price) {
    price.textContent = selected.dataset.price;
  }
});

document.addEventListener('submit', (event) => {
  const form = event.target.closest('.product-card__form, .product-form');
  if (!form) return;
  const button = form.querySelector('button[type="submit"]');
  if (!button || button.disabled) return;
  button.setAttribute('aria-busy', 'true');
});
